<!-- 由 suu 创建于 2022-09-01 星期四 -->
<template>
  <div class="sum-radar-chart">
    <div id="radar-chart"></div>
  </div>
</template>

<script>
export default {
  name: 'sum-radar-chart',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.initChart()
  },

  destroyed() {},

  methods: {
    initChart() {
      const all = this.info.allScore
      const arr = [
        this.info.stapleScore,
        this.info.proteinScore,
        this.info.vegetableScore,
        this.info.tasteScore,
        this.info.greaseScore
      ]
      let i = -1
      var option = {
        title: {
          text: all + '分',
          triggerEvent: false,
          textStyle: {
            color: 'rgba(255, 255, 255)', //标题颜色
            fontSize: 12,
            lineHeight: 24
          },
          // 标题的位置，此时放在图的底边
          left: 'center',
          top: 'center'
        },
        legend: {
          selectedMode: false
        },
        // 图表的位置
        grid: {
          position: 'center'
        },
        tooltip: {
          //雷达图的tooltip不会超出div，也可以设置position属性，position定位的tooltip
          confine: true,
          enterable: true //鼠标是否可以移动到tooltip区域内
        },
        radar: {
          radius: '56%', //大小
          selectedMode: false,
          shape: 'circle',
          splitNumber: 4, // 雷达图圈数设置
          name: {
            textStyle: {
              color: '#878787'
            }
          },
          // 设置雷达图中间射线的颜色
          axisLine: {
            lineStyle: {
              color: 'rgba(131,141,158,.1)'
            }
          },
          indicator: [
            {
              name: '主食',
              max: 100,
              //若将此属性放在radar下，则每条indicator都会显示圈上的数值，放在这儿，只在通信这条indicator上显示
              axisLabel: {
                show: false,
                fontSize: 12,
                color: '#838D9E',
                showMaxLabel: false, //不显示最大值，即外圈不显示数字30
                showMinLabel: true //显示最小数字，即中心点显示0
              }
            },
            { name: '蛋白质', max: 100 },
            { name: '蔬菜', max: 100 },
            { name: '饮食口味', max: 100 },
            { name: '油脂', max: 100 }
          ],
          //雷达图背景的颜色，在这儿随便设置了一个颜色，完全不透明度为0，就实现了透明背景
          splitArea: {
            show: true,
            areaStyle: {
              color: [
                // '#FFB8EC',
                'rgba(255,184,236,0.7)',
                'rgba(255,184,236,0.6)',
                'rgba(255,184,236,0.4)',
                'rgba(255,184,236,0.2)'
              ],
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
              // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色
            }
          },
          name: {
            rich: {
              a: {
                color: 'rgba(0,0,0,0.5)',
                fontWeight: 500,
                fontSize: 12
              },
              b: {
                color: '#000',
                fontSize: 15,
                fontWeight: 800,
                padding: 2
              }
            },
            formatter: (a, b) => {
              i++
              // return `{a|${a}}\n{b|${arr[i]}}`
              return `{a|${a}}{b|${arr[i]}}`
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              // color: 'rgba(131,141,158,.1)' // 设置网格的颜色
              color: '#FFEFF9' // 设置网格的颜色
            }
          }
        },
        series: [
          {
            name: '饮食回顾', // tooltip中的标题
            type: 'radar', //表示是雷达图
            // symbol: 'circle', // 拐点的样式，还可以取值'rect','angle'等
            symbolSize: 6, // 拐点的大小
            selectedMode: false,
            clickable: false,
            emphasis: {
              disabled: true
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              // normal: {
              //   // 1,
              //   opacity: 0.2
              // },
              color: new this.$parent.echarts.graphic.RadialGradient(
                0.1,
                0.6,
                1,
                [
                  {
                    color: 'rgba(255,134,178,0.6)',
                    offset: 0
                  },
                  {
                    color: 'rgba(255,134,178,0.5)',
                    offset: 1
                  }
                ]
              )
            },
            data: [
              {
                value: arr,
                // name: '2018-07',
                //这里的配置显示数值
                // label: {
                //   normal: {
                //     show: true,
                //     formatter: function (params) {
                //       return params.value
                //     }
                //   }
                // },
                // 设置区域边框和区域的颜色
                itemStyle: {
                  normal: {
                    color: 'rgba(255,134,178,0.3)',
                    // color: '#fff',
                    // borderColor: '#fff',
                    // borderWidth: 1,
                    lineStyle: {
                      color: '#FF53AF'
                    }
                  }
                }
              }
            ]
          }
        ]
      }
      var chartDom = document.getElementById('radar-chart')
      var myChart = this.$parent.echarts.init(chartDom, null, {
        renderer: 'svg'
      })
      option && myChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.sum-radar-chart {
  margin-top: 20px;
  #radar-chart {
    width: 290px;
    // flex: 1;
    height: 200px;
  }
}
</style>
